import React from "react";
import { Button, Carousel } from "antd";
import { HomeSliderData } from "../../helperFunction";
import "./styles.scss";
import { ArrowRightOutlined } from "@ant-design/icons";

const HomeSliderAll = () => {
  return (
    <Carousel
      arrows
      autoplay={false}
      dots={true}
      className="home-banner-carousel"
    >
      {HomeSliderData?.map((e) => {
        return (
          <div className="home-banner-container">
            <img src={e?.backGroundImg} alt="#" className="home-banner-img" />
            <div className="carousel-content">
              <div className="tile-button">
                <h2>{e.title}</h2>
                <p>{e.desc}</p>
                <Button
                  icon={<ArrowRightOutlined />}
                  iconPosition="end"
                  ghost
                  size="large"
                  className="carousel-button"
                  href="/games"
                >
                  View More
                </Button>
              </div>
              <img src={e?.gameImg} alt="#" className="game-img" />
            </div>
          </div>
        );
      })}
    </Carousel>
  );
};

export default HomeSliderAll;
